import { useAppDispatch, useAppSelector } from "../../redux/store";
import { InputContainer, LoginContainer } from "./styled";
import BarekamButton, {
  AuthButtons,
  SimpleButtons,
} from "../components/button";
import "react-phone-input-2/lib/material.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BarekamText from "../components/text";
import BarekamInput from "../components/input";
import "react-toastify/dist/ReactToastify.css";
import { Message, MessageSections } from "../components/message/message";
import {
  confirmResetToken,
  resetPassword,
} from "../../redux/slices/register-slice";
import { toast, ToastContainer } from "react-toastify";
import { PayloadAction } from "@reduxjs/toolkit";
import { Footer } from "../footer/footer";
import { mapValidationErrors } from "../user/settings/personal-info/personal-info.service";
import { getMessage } from "../shared/helper-functions";

const ChangePassword = () => {
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [password, setPassword] = useState<string>();
  const [isAbleToReset, setIsAbleToReset] = useState<boolean>(false);
  const [repeatedPassword, setRepeatedPassword] = useState<string>("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (queryParams.get("rt")) {
      dispatch(confirmResetToken(queryParams.get("rt") || "")).then(
        (confirmed) => {
          if (
            confirmed.payload &&
            confirmed.payload &&
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            confirmed.payload["status"] === 200
          ) {
            setIsAbleToReset(true);
          } else {
            initToast(
              getMessage(
                "something_went_wrong",
                MessageSections.LOGIN,
                messageCache,
                languageId,
              ),
              "error",
            );
          }
        },
      );
    }
  }, [navigate]);

  function changePassword(): void {
    if (passedValidations()) {
      dispatch(resetPassword({ password, token: queryParams.get("rt") })).then(
        (data: PayloadAction<any>) => {
          if (data.payload.error) {
            setErrors(mapValidationErrors(data.payload.error));
          } else {
            const options = {
              toastMessage: getMessage(
                "successfully_recovered",
                MessageSections.LOGIN,
                messageCache,
                languageId,
              ),
              toastType: "info",
            };
            navigate("../login", { state: options });
          }
        },
      );
    }
  }

  function passedValidations() {
    if (repeatedPassword !== password) {
      // TODO: use encryption
      setErrors({ password: "passwords_do_not_match" });
      return false;
    } else {
      return true;
    }
  }

  function initToast(message: string, type: string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    toast[type](message, {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  return (
    <>
      <LoginContainer>
        <InputContainer>
          {isAbleToReset && (
            <>
              <BarekamInput
                key={"register-password"}
                customInputVariant={"standard"}
                placeholder={getMessage(
                  "password",
                  MessageSections.LOGIN,
                  messageCache,
                  languageId,
                )}
                value={password}
                onKeyUp={(event) => event.key === "Enter" && changePassword()}
                onChange={(value) => setPassword(value.target.value)}
                type={"password"}
                errorMessage={
                  errors["password"] &&
                  getMessage(
                    errors["password"],
                    MessageSections.LOGIN,
                    messageCache,
                    languageId,
                  )
                }
                error={!!errors["password"]}
                width={"100%"}
                required
              />

              <BarekamInput
                key={"register-repeat-password"}
                customInputVariant={"standard"}
                placeholder={getMessage(
                  "repeat_password",
                  MessageSections.LOGIN,
                  messageCache,
                  languageId,
                )}
                value={repeatedPassword}
                onKeyUp={(event) => event.key === "Enter" && changePassword()}
                onChange={(value) => setRepeatedPassword(value.target.value)}
                type={"password"}
                error={!!errors["password"]}
                errorMessage={
                  errors["password"] &&
                  getMessage(
                    errors["password"],
                    MessageSections.LOGIN,
                    messageCache,
                    languageId,
                  )
                }
                width={"100%"}
                required
              />

              <BarekamButton
                type={AuthButtons.MAIN}
                size={"l"}
                onClick={changePassword}
              >
                <BarekamText variant={"l"} fontWeight={700} align={"center"}>
                  <Message
                    messageKey={"change_password"}
                    sectionId={MessageSections.LOGIN}
                  />
                </BarekamText>
              </BarekamButton>
            </>
          )}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => navigate("../login")}
            >
              <BarekamText variant={"m"}>
                <Message
                  messageKey={"to_log_in"}
                  sectionId={MessageSections.LOGIN}
                />
              </BarekamText>
            </BarekamButton>
          </div>
        </InputContainer>
      </LoginContainer>

      <Footer />

      <ToastContainer />
    </>
  );
};

export default ChangePassword;
